import { defineStore } from 'pinia'

const usePersonnelStore = defineStore('personnel', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default usePersonnelStore
